import React, { useState, useEffect, useRef } from 'react'
import { Field, useField } from 'formik'

import {
  Input,
  SelectButton,
  Container,
  Options,
  SearchInput,
  ErrorMessage,
} from './styles'
import TplGroup from '../tpl-group'
import IField from '../../../../interfaces/field'
import Icon from '../../../icon'

type IProps = any & IField

const SelectChecklist = ({
  required = false,
  name,
  prefixName,
  title,
  options,
  onChange,
  ...el
}: IProps) => {
  const [checklistIsOpen, setChecklistIsOpen] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [optionsList, setOptionsList] = useState(options)
  const [field, meta] = useField(name)
  const containerRef = useRef<HTMLDivElement | null>(null)

  const handleOptionChange = (optionValue: any) => {
    const currentValues = field.value || []
    const updatedValues = currentValues.includes(optionValue)
      ? currentValues.filter((value: any) => value !== optionValue)
      : [...currentValues, optionValue]

    field.onChange({
      target: {
        name,
        value: updatedValues,
      },
    })

    if (onChange) {
      onChange(updatedValues)
    }
  }

  const handleClickOutside = (event: any) => {
    if (
      containerRef.current
      && !containerRef.current.contains(event.target)
      && event.target.name !== 'searchInput'
    ) {
      setChecklistIsOpen(false)
    }
  }

  const handleSelectButtonClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLInputElement
    if (target?.name !== 'searchInput') {
      setChecklistIsOpen((state: boolean) => !state)
    }
  }

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    if (searchValue) {
      const filteredOptions = options.filter((option: any) => (option?.label
        ? option.label.toLowerCase().includes(searchValue.toLowerCase())
        : option.toLowerCase().includes(searchValue.toLowerCase())))
      setOptionsList(filteredOptions)
    } else {
      setOptionsList(options)
    }
  }, [searchValue, options])

  let selectButtonContent
  if (checklistIsOpen) {
    selectButtonContent = (
      <SearchInput
        name="searchInput"
        value={searchValue}
        onChange={handleSearchInputChange}
        placeholder="Buscar..."
        key="searchInput"
      />
    )
  } else if (field.value && field.value.length > 0) {
    selectButtonContent = `${field.value.length} selecionado(s)`
  } else {
    selectButtonContent = el.placeholder
  }

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      prefixName={prefixName}
      title={title}
      required={required}
      {...el}
    >
      <Container ref={containerRef}>
        <SelectButton onClick={handleSelectButtonClick}>
          {selectButtonContent}
          <Icon name="arrow-down" />
        </SelectButton>

        <Options
          style={{
            ...el.containerStyle,
            display: checklistIsOpen ? 'flex' : 'none',
          }}
        >
          {optionsList.map((option: any) => (
            <div key={JSON.stringify(option)} style={{ ...el.style }}>
              <Field
                type="checkbox"
                name={name}
                value={option?.value || option}
                as={Input}
                onChange={() => handleOptionChange(option?.value || option)}
                key={`field-${JSON.stringify(option)}`}
              />
              <span key={`label-${JSON.stringify(option)}`}>
                {option?.label || option}
              </span>
            </div>
          ))}
        </Options>
        {meta.touched && meta.error && (
          <ErrorMessage>{meta.error}</ErrorMessage>
        )}
      </Container>
    </TplGroup>
  )
}

export default SelectChecklist
